 async function callApi<T>(
    apiMethod: Promise<T>, 
    setResultMethod: { (value: React.SetStateAction<any | undefined>): void; (arg0: any): void; },
    setLoadingMethod?: { (value: React.SetStateAction<any | undefined>): void; (arg0: any): void; } | undefined
) {
    if (setLoadingMethod !== undefined) {
        setLoadingMethod(true);
    }
    
    try
      {
          const t = await apiMethod;
          if (t !== undefined) {
            setResultMethod(t);
            if (setLoadingMethod !== undefined) {
                setLoadingMethod(false);
            }
          }
      }
      catch (error)
      {
        if (setLoadingMethod !== undefined) {
            setLoadingMethod(false);
        }
      }
  }

  export default callApi;